import React, { useState, useEffect } from "react";
import { Button } from "@bphxd/ds-core-react";
import { DoubleArrowLeft16,DoubleArrowRight16 } from "@bphxd/ds-core-react/lib/icons";
import "./PaginationControls.scss";

interface PaginationControlsProps {
  currentPage: number;
  totalRecords: number;
  pageSize: number;
  onPageChange: (pageNum: number) => void;
}

export default function PaginationControls({
  currentPage,
  totalRecords,
  pageSize,
  onPageChange,
}: PaginationControlsProps) {
  const [inputPage, setInputPage] = useState<string>(currentPage.toString());
  const totalPages = Math.ceil(totalRecords / pageSize);

  useEffect(() => {
    setInputPage(currentPage.toString());
  }, [currentPage]);

  const handleGoToPage = () => {
    const pageNum = parseInt(inputPage, 10);
    if (pageNum >= 1 && pageNum <= totalPages) {
      onPageChange(pageNum);
    } else {
      alert(`Please enter a page number between 1 and ${totalPages}`);
      setInputPage(currentPage.toString());
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleGoToPage();
    }
  };

  return (
    <div className="pagination-controls">
      <Button
        level="secondary"
        size="sm"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <DoubleArrowLeft16 style={{ marginRight: "1px" }} />
        Previous
      </Button>

      <div className="page-input-group">
        <label htmlFor="page-input">Go to page: </label>
        <input
          id="page-input"
          type="number"
          min="1"
          max={totalPages}
          value={inputPage}
          onChange={(e) => setInputPage(e.target.value)}
          onKeyPress={handleKeyPress}
          className="page-input"
        
        />
        <Button level="primary" size="sm" onClick={handleGoToPage} style={{ marginLeft: "8px" }}>
          Go
        </Button>
      </div>

      <span className="page-info">
        Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong> ({totalRecords} total records)
      </span>

      <Button
        level="secondary"
        size="sm"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        Next
        <DoubleArrowRight16 style={{ marginLeft: "1px" }} />
      </Button>
    </div>
  );
}